import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IQuickActions = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="3.2" cy="3.2" r="3.2" fill="#37474F" />
            <circle cx="3.2" cy="12.7996" r="3.2" fill="#37474F" />
            <circle cx="12.8001" cy="3.2" r="3.2" fill="#37474F" />
            <circle cx="12.8001" cy="12.7996" r="3.2" fill="#37474F" />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IQuickActions;
